const DEVICE_ID_KEY = 'admin_device_id';

/**
 * localStorage에서 디바이스 ID를 읽거나, 없으면 새로 생성하여 저장
 */
export function getDeviceId(): string {
  const stored = localStorage.getItem(DEVICE_ID_KEY);
  if (stored) {
    return stored;
  }

  const newId = crypto.randomUUID();
  localStorage.setItem(DEVICE_ID_KEY, newId);
  return newId;
}
